import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./lib/LanguageContext";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Apartments } from "./components/Apartments";
import { Facilities } from "./components/Facilities";
import { Location } from "./components/Location";
import { Gallery } from "./components/Gallery";
import { ReviewBlock } from "./components/ReviewBlock";
import { BookingForm } from "./components/BookingForm";
import { Footer } from "./components/Footer";
import { GalleryPage } from "./pages/GalleryPage";

const Landing = () => {
  return (
    <main data-testid="landing-root" className="bg-[#faf9f6] text-[#0a192f]">
      <Header />
      <Hero />
      <About />
      <Apartments />
      <Facilities />
      <Location />
      <Gallery />
      <ReviewBlock />
      <BookingForm />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/gallery" element={<GalleryPage />} />
          </Routes>
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#0a192f",
                color: "#faf9f6",
                border: "1px solid rgba(255,255,255,0.1)",
                borderRadius: "16px",
                fontFamily: "Outfit, sans-serif",
              },
            }}
          />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
